import { type ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
// import useMessageExpireTimer from '@/scripts/hooks/useMessageExpireTimer';
import styles from './index.module.scss';
import TimeIcon from './images/time.svg?react';

interface MessageExpireTimeProps {
  message?: ChatMessage;
  chat?: Chat;
  displayTime: string;
}

const MessageExpireTime = ({ displayTime }: MessageExpireTimeProps) => {
  return (
    <div className={styles.messageExpireTime}>
      {displayTime}
      <TimeIcon />
    </div>
  );
};

export default MessageExpireTime;
